import React from 'react';
import {connect} from 'react-redux';

import {Grid} from '@mui/material';

import {createResource, logout} from 'spectra-logic-ui/actions';
import {setAuthEnabled} from 'spectra-logic-ui/app/auth';
import {FormDialog} from 'spectra-logic-ui/components';
import {Dispatch} from 'spectra-logic-ui';

import {Activate} from '@/help';
import MaterialTextField from '@mui/material/TextField';
import {FormValues} from '@/accounts/form/types';
import {RegistrationData} from '@/dashboard/types';
import makeStyles from '@mui/styles/makeStyles';

type Props = {
  onSubmit: (values: FormValues) => Promise<any>;
  registrationData?: RegistrationData;
}

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    width: '100%',
  },
  textField: {
    display: 'flex',
    flex: '1 1 auto',
  },
});

const RegisterCloudlessDialog = ({onSubmit, registrationData, ...otherProps}: Props) => {
  const classes = useStyles();
  return (
    <FormDialog title='Register Local Control' onSubmit={onSubmit} getHelpLocation={() => Activate} {...otherProps}>
      {() => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.root}>
              <MaterialTextField
                variant='standard'
                className={classes.textField}
                name='key' label='Sphere Activation Key' value={registrationData?.activationKey}
                disabled={true}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.root}>
              <MaterialTextField name='url' label='Alternate Endpoint'
                variant='standard'
                className={classes.textField}
                value={registrationData?.licenseEndpoint}
                disabled={true}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.root}>
              <p>To change these values, re-run activation.</p>
            </div>
          </Grid>
        </Grid>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const onSuccess = () => {
    // Cloud control registration returns a JWT token since the user already validated
    // their credentials during registration. Local control doesn't return a JWT since
    // the user doesn't submit any credentials during registration. Thus, the user
    // needs to be sent back to the login page. Auth has to be flagged as enabled now, because
    // Vail's login page has a check to redirect back to the dashboard if auth is disabled
    // (which it is prior to registering); an infinite dashboard->login->dashboard routing
    // loop will result if this is not done. The page also needs to be reloaded to fully
    // reset the auth state since it's intended to be bootstrapped.
    setAuthEnabled(true);
    dispatch(logout());
    window.location.reload();
  };
  return {
    onSubmit: (values: FormValues) => (
      dispatch(createResource('sphere/cloudless', values, {onSuccess: onSuccess}))
    ),
  };
};

export default connect(undefined, mapDispatchToProps)(RegisterCloudlessDialog);
